// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bottom":"assessor-update-wwc__bottom--3ur_S"};